// extracted by mini-css-extract-plugin
export var externalLink = "_cw-0";
export var internalLinkLabel = "_cw-1";